module.exports = __webpack_public_path__ + "static/uw-madison-19b079f64bf49e257a77364cc680a8df.png";